import { Controller } from "@hotwired/stimulus"

// Stepper − N + genérico del wizard: mueve el input de `step` en `step` dentro de [min, max] y dispara `input`.
// Doc: _docs/features/products/partner_product_form.md
export default class extends Controller {
  static targets = ["input", "display", "dec", "inc"]
  static values = {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 1000000 },
    step: { type: Number, default: 1 },
    suffix: { type: String, default: "" }
  }

  connect() {
    // Un number editable también cambia a mano: los botones siguen al valor
    this.onInput = () => this.sync()
    this.inputTarget.addEventListener("input", this.onInput)
    this.sync()
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.onInput)
  }

  minValueChanged() {
    if (this.hasInputTarget) this.sync()
  }

  maxValueChanged() {
    if (this.hasInputTarget) this.sync()
  }

  increment() {
    this.#apply(1)
  }

  decrement() {
    this.#apply(-1)
  }

  // Repinta desde el input; readonly o disabled (stock bloqueado por el plan) apaga los dos botones
  sync() {
    const value = this.#current()
    const locked = this.#locked()
    if (this.hasDisplayTarget) this.displayTarget.textContent = value === null ? "" : `${value}${this.suffixValue}`
    if (this.hasDecTarget) this.decTarget.disabled = locked || (value !== null && value <= this.minValue)
    if (this.hasIncTarget) this.incTarget.disabled = locked || (value !== null && value >= this.maxValue)
  }

  #locked() {
    return Boolean(this.inputTarget.readOnly || this.inputTarget.disabled)
  }

  #current() {
    const raw = this.inputTarget.value
    const value = Number(raw)
    return raw === "" || !Number.isFinite(value) ? null : value
  }

  #apply(direction) {
    if (this.#locked()) return
    const current = this.#current()
    let next = current === null ? this.minValue : current + direction * this.stepValue
    next = Math.min(this.maxValue, Math.max(this.minValue, next))
    if (next === current) return
    this.inputTarget.value = next
    this.sync()
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.dispatch("change", { detail: { value: next } })
  }
}
